import { PerformanceMode } from '@cbsinteractive/avia-js';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';
export class PlayStation4 extends AbstractSTVPlatformConfig {
    constructor(params) {
        super(params);
        this.configs.properties.device = EmbedDevice.PS4;
        this.configs.playerOptions.performanceMode = PerformanceMode.LOW;
        this.configs.resourceConfig.playback.manifest = {
            dash: {
                ignoreMinBufferTime: true
            }
        };
        this.configs.resourceConfig.playback.streaming = {
            bufferBehind: 2,
            bufferingGoal: 6,
            rebufferingGoal: 18
        };
    }
}
